import React, { useState, useEffect } from "react";
import { Grid, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {paths} from "../../AppRouters";
import desktop from '../../assets/images/location_campaign/banner-site-desktop.png';
import mobile from '../../assets/images/location_campaign/banner-site-mobile.png';

const HomeBannerLocation: React.FC = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNavigateToNcp = () => {
        navigate(`${paths.locationCampaign}?code=00000`);
    };

     return (
        <Grid container>
            <Grid item xs={12} style={{position: 'relative'}}>
                {/* Banner pentru desktop - clickabil */}
                {!isMobile && (
                    <img 
                        src={desktop} 
                        alt={'Kozel Mix Țapăn 2025'} 
                        onClick={handleNavigateToNcp}
                        style={{
                            width: '100%',
                            height: 'auto',
                            cursor: 'pointer',
                            display: 'block'
                        }}
                    />
                )}
                
                {/* Imaginea pentru mobile */}
                {isMobile && (
                    <img 
                        src={mobile} 
                        alt={'Kozel Mix Țapăn 2025'} 
                        onClick={handleNavigateToNcp}
                        style={{
                            width: '100%',
                            height: 'auto',
                            cursor: 'pointer',
                            display: 'block'
                        }}
                    />
                )}
            </Grid>
        </Grid>
    );
};

export default HomeBannerLocation;